import ApiService from './api'

const BASE_URL = '/hr/employee-shifts'

export const employeeShiftService = {
  // Get all employee shifts with filters
  getEmployeeShifts: async (params = {}) => {
    try {
      // Add populate parameter to get full job and branch objects
      const defaultParams = {
        populate: 'employee.job,employee.branch',
        ...params
      }
      
      const queryString = new URLSearchParams(
        Object.entries(defaultParams).filter(([, value]) => value !== undefined && value !== '')
      ).toString()
      
      const url = queryString ? `${BASE_URL}?${queryString}` : BASE_URL
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      console.error('Error fetching employee shifts:', error)
      throw error
    }
  },

  // Get employee shift by ID
  getEmployeeShiftById: async (shiftId) => {
    try {
      const response = await ApiService.get(`${BASE_URL}/${shiftId}?populate=employee.job,employee.branch`)
      return response
    } catch (error) {
      console.error('Error fetching employee shift:', error)
      throw error
    }
  },

  // Create a new employee shift
  createEmployeeShift: async (shiftData) => {
    try {
      const response = await ApiService.post(BASE_URL, shiftData)
      return response
    } catch (error) {
      console.error('Error creating employee shift:', error)
      throw error
    }
  },

  // Create multiple employee shifts
  createMultipleEmployeeShifts: async (shiftData) => {
    try {
      const response = await ApiService.post(`${BASE_URL}/multiple`, shiftData)
      return response
    } catch (error) {
      console.error('Error creating multiple employee shifts:', error)
      throw error
    }
  },

  // Update an employee shift
  updateEmployeeShift: async (shiftId, shiftData) => {
    try {
      const response = await ApiService.patch(`${BASE_URL}/${shiftId}`, shiftData)
      return response
    } catch (error) {
      console.error('Error updating employee shift:', error)
      throw error
    }
  },

  // Delete an employee shift
  deleteEmployeeShift: async (shiftId) => {
    try {
      const response = await ApiService.delete(`${BASE_URL}/${shiftId}`)
      return response
    } catch (error) {
      console.error('Error deleting employee shift:', error)
      throw error
    }
  },

  // Get available employees without shifts
  getAvailableEmployees: async (branchId) => {
    try {
      const url = `${BASE_URL}/available-employees?branchId=${branchId}&populate=job,branch`
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      console.error('Error fetching available employees:', error)
      throw error
    }
  }
}

export default employeeShiftService
